// extracted by mini-css-extract-plugin
module.exports = {"table-container":"StrTable_table-container__3K8fd","table":"StrTable_table__3dxk6"};